export const TOTALDONATIONSTHISYEAR_LABELS = {
  counter: {
    en: "Total Donations (Amount) - This Year",
    ta: "மொத்த நன்கொடைகள் (தொகை) - இந்த ஆண்டு",
    si: "මුළු පරිත්‍යාග (මුදල) ​​- මෙම වසරේ",
  },
};
